import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadReasonListAllSuccessful, loadReasonListAllFailed } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadReasonListAll(action) {
  try {
    const {
      payload = {
      },
    } = action;
    const {
      filter,
    } = payload;
    let pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/resources/rejection-reasons/all`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadReasonListAllSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadReasonListAllFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadReasonListAllFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
